// import React, { useState } from 'react';
import React from 'react';
import { array, object } from 'prop-types';

// import Hotels from './Hotels';
import Locations from './Locations';

function FilteringDesktop({ filtered, theme }) {
  // const [hasHotels, setHasHotels] = useState(true);

  return (
    <div className="grid-x align-center filter-offer-location">
      <div className="cell large-12 filtered-locations">
        <h2 className="filtered-title">Locations</h2>
        <div className="find-a-hotel-suggestions offers-filter-suggestions">
          <Locations filtered={filtered} theme={theme} />
        </div>
      </div>
      {/* {hasHotels ? (
        <div className="cell large-6 filtered-hotels">
          <h2 className="filtered-title">Hotels</h2>
          <div className="find-a-hotel-suggestions">
            <Hotels filtered={filtered} setHasHotels={setHasHotels} />
          </div>
        </div>
      ) : (
        <div className="cell small-6 filtered-hotels" />
      )} */}
    </div>
  );
}

FilteringDesktop.propTypes = {
  filtered: array.isRequired,
  theme: object
};

export default FilteringDesktop;
